var path = '/analytics/component/tpl/consent-modal.html';
var html = "<div class=\"modal-body consent-wrapper\"> <h2 ng-bind=$ctrl.title></h2> <p dynamic-bind-html={{$ctrl.description}}></p> <div class=\"buttons-wrapper text-center\"> <button type=button class=\"btn btn-tm btn-default\" ng-click=$ctrl.onReject()>Reject</button> <span class=button-spacer></span> <button type=button class=\"btn btn-tm btn-primary\" ng-click=$ctrl.onApprove()>Accept</button> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/analytics/component/tpl/consent-modal.html
// module id = 308
// module chunks = 0 1 2 3 4